<template>
  <quill-editor
    :value="props.value"
    @change="onEditorChange"
    :options="options"
  />
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { customStorage } from "@/service/customStorage";
import { apiUrl } from "@/service/user.service"
import axios from "axios";
import { quillEditor } from "vue3-quill";
import ImageCompress from "quill-image-compress";
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import htmlEditButton from "quill-html-edit-button";
import Quill from "quill";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "@taoqf/quill-image-resize-module";
   
import BlotFormatter from 'quill-blot-formatter';
import ImageUploader from "quill-image-uploader";
import 'quill-image-uploader/dist/quill.imageUploader.min.css';

Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/htmlEditButton", htmlEditButton);
Quill.register("modules/imageCompress", ImageCompress); 
Quill.register('modules/blotFormatter', BlotFormatter);
Quill.register("modules/imageUploader", ImageUploader);

Quill.debug("error");


//Quill.debug("error");
   
const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
    ['link', 'image', 'video', 'formula'],
    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': ['', 'center', 'right', 'justify'] }],
  // ['clean']                                         // remove formatting button
];

const options = {
      placeholder: 'Начните добавлять текст сюда',
      modules: {
        toolbar: toolbarOptions,
     
     
         htmlEditButton: {
                  debug: true,
                  syntax: false,
                  buttonTitle: 'Показать HTML код',
                  msg: 'Отредактируйте HTML  в этом окне,  для сохранения нажмите - сохранить',
                  okText: 'Сохранить',
                  cancelText: 'Отмена',
                  buttonHTML: '&#9883;',
                  prependSelector: 'div#myelement',
                  editorModules: {},
                },

        imageUploader: {
                    upload: (file) => {
                        return new Promise((resolve, reject) => {
                            const formData = new FormData();
                            formData.append("file", file);

                            axios.post(apiUrl + "upload/image" , formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    Authorization: "Bearer " + customStorage.get("user-token"),
                                }}).then((res) => {
                                    console.log("upload result: " + res)
                                    if (res.status === 201) {
                                        resolve(res.data)  
                                    }
                                }).catch((error) => {
                                    console.log("Error: " + error);
                                    reject(error)
                                });
                                
                        });
                    }
        },
         imageDrop: true,
            blotFormatter: {
                specs: [   
                ],
                overlay: {
                    style: {
                        border: '2px solid red',
                    }
                }
            },

            imageResize: {
                imageCompress: {
                    quality: 0.9,
                    maxWidth: 200,
                    maxHeight: 200,
                    imageType: 'image/jpeg',
                    debug: true,
                    suppressErrorLogging: false,
                    insertIntoEditor: undefined,
                }
            },

        
      },
    }


const emit = defineEmits(["update:value"]);
const props = defineProps(["value"]);

const onEditorChange = ({ html }) => {
  // console.log("editor change!", quill, html, text);
  emit("update:value", html);
};
</script>
